import React, {Component} from 'react';
import ClientPageBackButton from "./../ClientPageBackButton";
import ScrollToComponent from "../ScrollToComponent";


export default class ONamaEnglishPage extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<main>
                <div className="main about clearfix">

                    <section className="clearfix o-nama-first"></section>
                    <section className="orange-o-nama">
                        <div className="">
                            <h1 className="contact-title">ABOUT US</h1>
                            <p>Smart Agency has been in the business for 10 years. The Smart team is comprised of professionals in the fields of marketing, PR and design, with over 100 years of experiences in different areas of these activities – between them, of course.</p>
                            <p>Understanding the needs of our clients, absolute dedication to creative tasks and aim to turn those needs into good and significant marketing actions is what differentiates us from the rest. We often say that we fight for each our clients’ projects as if we were the ones competing on the market. Knowledge, energy, inspiration and enthusiasm are the most important features on our Identity Card.</p>
                            <p>When they ask us which brand or project we love most... you know how the old saying goes, “we love all of our children”, we simply cannot decide. And we learn from each of them a little something too!</p>
                        </div>
                    </section>
                    <div className="o-nama-box left-person clearfix">
                        <div className="person-info person-info-1">
                            <div className="left-info">
                                <div className="name">
                                    <h4 className="orange-title">JELENA</h4>
                                    <h5>Petrović-Zvekić</h5>
                                </div>
                                <p>Partner & CEO</p>
                                <div className="box-text">
                                    <p>Master in marketing management, specialist in media relations and media buying. Almost 20 years of professional experience in marketing, in top management positions, especially in the field of brand launching, brand development and strategic brand management. </p>
                                    <p>She started her career through the development of the brands "Gorki list" and "Sinalco", and then spent the next 9 years as the director of marketing and development of the famous brand in the fashion industry "Legend WorldWide", then as a consultant for different clients, such as one of the biggest pharmaceutical companies in the region, Goodwill Pharma, and one of the biggest integrated oil and gas companies Euro Petrol and Euro Gas. She has long-term experience in managing complex marketing projects, cooperating with media, media rent, creating sales and marketing strategies. For the last ten years, engaged as a partner and director of Smart agency.</p>
                                </div>
                            </div>
                        </div>
                        <img className="img-person-right" src="/img/jelena-slika.jpg" alt="jelena smart agency"/>
                    </div>
                    <div className="o-nama-box right-person clearfix">
                        <img className="img-person-left" src="/img/ivana-slika.jpg" alt="ivana smart agency"/>
                            <div className="person-info person-info-2">
                                <div className="right-info">
                                    <div className="name">
                                        <h4 className="orange-title">IVANA</h4>
                                        <h5>Jovanović</h5>
                                    </div>
                                    <p>Partner & Creative Director</p>
                                    <div className="box-text">
                                        <p>Bachelor of arts in teaching literature. Specialized in creating marketing concepts and promotional campaigns for clients, event management and other creative tasks.  </p>
                                        <p>Eighteen years of experience in copywriting, PR activities and corporate creative development. Working in management positions for eight years and 10 years as a partner and creative director. Linguist. Journalist. Writes columns for several popular magazines and portals.</p>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div className="o-nama-box left-person clearfix">
                        <div className="person-info person-info-1">
                            <div className="left-info">
                                <div className="name">
                                    <h4 className="orange-title">DANIELA</h4>
                                    <h5>Bucalo</h5>
                                </div>
                                <p>Partner & Art director</p>
                                <div className="box-text">
                                    <p>Graduated in graphic design at the Faculty of Applied Arts in Belgrade.</p>
                                    <p>Over 18 years of experience as an art director of renowned foreign and domestic companies (Zepter International, ZlatibO2r voda, Higlo), and marketing director (Vinarija Čoka), as well as consultant for the development of visual brand concepts (Euro Petrol and Euro Gas). Member of ULUPUDS, winner of awards for graphic design. For the last 10 years works as a partner and art director of the Smart Agency.</p>

                                </div>
                            </div>
                        </div>
                        <img className="img-person-right" src="/img/daniela-slika.jpg" alt="daniela smart agency"/>
                    </div>
                    <div className="o-nama-box right-person clearfix">
                        <img className="img-person-left" src="/img/viktor-slika.jpg" alt="viktor smart agency"/>
                            <div className="person-info person-info-2">
                                <div className="right-info">
                                    <div className="name">
                                        <h4 className="orange-title">VIKTOR</h4>
                                        <h5>Juriga</h5>
                                    </div>
                                    <p>Graphic designer</p>
                                    <div className="box-text">
                                        <p>Has been doing graphic design for the last 18 years in various companies and on projects ranging from packaging, pharmaceutical product design, branding of various communication tools, and complex promotional campaigns.</p>
                                        <p>Graduated at Lakeland College, Cleveland, Ohio, in 1996 with Associate Degree in Applied Graphic Design. Received numerous awards and participated in numerous exhibitions in Serbia. Works with Smart Agency since 2015.</p>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div className="o-nama-box left-person clearfix">
                        <div className="person-info person-info-1">
                            <div className="left-info">
                                <div className="name">
                                    <h4 className="orange-title">LARISA</h4>
                                    <h5>Ivanković</h5>
                                </div>
                                <p>Junior marketing manager</p>
                                <div className="box-text">
                                    <p>Graduated at Faculty of Economics in Subotica at the department of Marketing Management.</p>
                                    <p>She participated in different informal workshops (public performance and communication, psychology, art, etc.). Her creative sensibility is best expressed in different forms of art and culture, like digital drawing, graphic design and music.</p>
                                </div>
                            </div>
                        </div>
                        <img className="img-person-right" src="/img/lara-slika.jpg" alt="lara smart agency"/>
                    </div>
                    <div className="o-nama-box right-person clearfix">
                        <img className="img-person-left" src="/img/rio-slika.jpg" alt="rio smart agency"/>
                            <div className="person-info person-info-2">
                                <div className="right-info">
                                    <div className="name">
                                        <h4 className="orange-title">Damir</h4>
                                        <h5>Lučić</h5>
                                    </div>
                                    <p>Graphic designer</p>
                                    <div className="box-text">
                                        <p>Over 20 years of experience as a graphic designer. Simultaneously with the career of a graphic designer, he dabbled in drawing comics and listening to experimental music in underground clubs, exchanging experience with local art groups. Making of Styrofoam sculptures led to a collaboration in fashion industry.</p>
                                        <p>Spent five years working with the most famous regional fashion brand. Interested in flash animation, worked on websites of famous companies. Whenever possible, experiments in the field of comics. Spends rest of his time working for Smart agency.</p>
                                    </div>
                                </div>
                            </div>
                    </div>

                </div>
            </main>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/English/ONamaEnglishPage.js